import type { Case, NodeTemplate, Node } from '../types'
import { CIVIL_LITIGATION_NODES, TRADEMARK_ADMIN_NODES } from '../types'

export function inferNodes(caseData: Case): Partial<Node>[] {
  const templates = caseData.case_type === 'trademark_admin'
    ? TRADEMARK_ADMIN_NODES
    : CIVIL_LITIGATION_NODES

  const nodes: Partial<Node>[] = []
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  for (const template of templates) {
    if (template.applicableRole !== 'all' && template.applicableRole !== caseData.party_role) {
      continue
    }

    let startDate: Date
    let endDate: Date

    switch (template.name) {
      case '法院审查立案':
        startDate = caseData.filing_date ? new Date(caseData.filing_date) : today
        endDate = new Date(startDate.getTime() + template.durationDays * 24 * 60 * 60 * 1000)
        break
      case '送达被告':
        startDate = caseData.filing_date ? new Date(caseData.filing_date) : today
        endDate = new Date(startDate.getTime() + template.durationDays * 24 * 60 * 60 * 1000)
        break
      case '答辩期':
      case '管辖权异议期':
      case '反诉期':
        startDate = caseData.filing_date
          ? new Date(new Date(caseData.filing_date).getTime() + 3 * 24 * 60 * 60 * 1000)
          : today
        endDate = new Date(startDate.getTime() + template.durationDays * 24 * 60 * 60 * 1000)
        break
      case '举证期（普通程序）':
      case '举证期（简易程序）':
      case '举证期':
        startDate = caseData.filing_date
          ? new Date(new Date(caseData.filing_date).getTime() + 7 * 24 * 60 * 60 * 1000)
          : today
        endDate = new Date(startDate.getTime() + template.durationDays * 24 * 60 * 60 * 1000)
        break
      case '诉讼费缴纳':
        startDate = caseData.filing_date ? new Date(caseData.filing_date) : today
        endDate = new Date(startDate.getTime() + template.durationDays * 24 * 60 * 60 * 1000)
        break
      case '开庭审理':
      case '一审开庭':
        startDate = caseData.filing_date
          ? new Date(new Date(caseData.filing_date).getTime() + 30 * 24 * 60 * 60 * 1000)
          : today
        endDate = startDate
        break
      case '上诉期（判决）':
        startDate = caseData.filing_date
          ? new Date(new Date(caseData.filing_date).getTime() + 45 * 24 * 60 * 60 * 1000)
          : today
        endDate = new Date(startDate.getTime() + template.durationDays * 24 * 60 * 60 * 1000)
        break
      case '上诉期（裁定）':
        startDate = caseData.filing_date
          ? new Date(new Date(caseData.filing_date).getTime() + 45 * 24 * 60 * 60 * 1000)
          : today
        endDate = new Date(startDate.getTime() + template.durationDays * 24 * 60 * 60 * 1000)
        break
      case '上诉费缴纳':
        startDate = caseData.filing_date
          ? new Date(new Date(caseData.filing_date).getTime() + 46 * 24 * 60 * 60 * 1000)
          : today
        endDate = new Date(startDate.getTime() + template.durationDays * 24 * 60 * 60 * 1000)
        break
      case '二审举证期':
        startDate = caseData.filing_date
          ? new Date(new Date(caseData.filing_date).getTime() + 60 * 24 * 60 * 60 * 1000)
          : today
        endDate = new Date(startDate.getTime() + template.durationDays * 24 * 60 * 60 * 1000)
        break
      case '申请执行':
        startDate = caseData.filing_date
          ? new Date(new Date(caseData.filing_date).getTime() + 90 * 24 * 60 * 60 * 1000)
          : today
        endDate = new Date(startDate.getTime() + template.durationDays * 24 * 60 * 60 * 1000)
        break
      case '起诉期限':
        startDate = caseData.filing_date ? new Date(caseData.filing_date) : today
        endDate = new Date(startDate.getTime() + template.durationDays * 24 * 60 * 60 * 1000)
        break
      case '一审判决':
      case '二审判决（终审）':
      case '二审开庭':
        startDate = caseData.filing_date
          ? new Date(new Date(caseData.filing_date).getTime() + 45 * 24 * 60 * 60 * 1000)
          : today
        endDate = startDate
        break
      default:
        startDate = caseData.filing_date ? new Date(caseData.filing_date) : today
        endDate = new Date(startDate.getTime() + template.durationDays * 24 * 60 * 60 * 1000)
    }

    const finalEndDate = endDate || new Date(startDate.getTime() + template.durationDays * 24 * 60 * 60 * 1000)

    nodes.push({
      node_name: template.name,
      duration_days: template.durationDays,
      start_date: startDate.toISOString().split('T')[0],
      end_date: finalEndDate.toISOString().split('T')[0],
      applicable_role: template.applicableRole,
      trigger_doc_id: null,
      status: 'upcoming',
      action_required: template.actionRequired,
      priority: template.priority,
      notes: `自动推断节点：${template.triggerCondition}`,
      completed_at: null,
      case_id: caseData.id,
    })
  }

  return nodes
}
